import React from "react";
import { ShieldCheckIcon } from "lucide-react";
import { images } from "../data/content";
import { CtaButton } from "./CtaButton";
import { Countdown } from "./Countdown";
export function HeroSection() {
  return <header className="w-full bg-cream px-5 pb-14 pt-8 sm:pt-12" data-id="element-161" data-mp="23w37sc5vrxep">
      <div className="mx-auto flex max-w-4xl flex-col items-center text-center" data-id="element-162" data-mp="28tuxr0myt9g9">
        <div className="flex items-center gap-2.5" data-id="element-163" data-mp="28vz9u5v0perm">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-ink text-gold" data-id="element-164" data-mp="2wl0erj4n67s5">
            <ShieldCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-165" data-mp="30k0uutvqiwbg" />
          </span>
          <span className="font-serif text-lg font-extrabold text-ink sm:text-xl" data-id="element-166" data-mp="2msunycq4lwej">The Sexual Control Protocol™</span>
        </div>

        <h1 className="mt-7 font-serif text-[36px] font-black leading-[1.08] tracking-tight text-ink sm:text-6xl" data-id="element-167" data-mp="2rr5ykpo8waxt">
          Recognize and regulate your arousal <em className="text-gold-dark" data-id="element-168" data-mp="3k9tg5v4197u5">before you lose control</em>
        </h1>

        <p className="mt-5 max-w-2xl text-[17px] leading-relaxed text-ink/75 sm:text-xl" data-id="element-169" data-mp="2ffidvz57lhso">
          A simple <strong className="text-ink" data-id="element-170" data-mp="2be6uibcxhssx">28-day system</strong> you can practice in <strong className="text-ink" data-id="element-171" data-mp="2bbu3l8p7083q">5–15 minutes a day</strong>. Includes{" "}
          <strong className="text-ink" data-id="element-172" data-mp="2p6wfqdkmutoz">6 premium volumes</strong>, <strong className="text-ink" data-id="element-173" data-mp="2ke3cxv8q5vfj">5 exclusive bonuses</strong>, guided practices and personal tracking tools.
        </p>

        <img src={images.mainMockup} alt="The Sexual Control Protocol — 6 volumes, tracker, journal and quick-reference tools" className="mt-8 w-full max-w-3xl" data-id="element-174" data-mp="2z2g84pzzna8z" />

        <div className="mt-6 w-full" data-id="element-175" data-mp="383xpebp4thz9">
          <CtaButton id="hero-cta" label="Get The Sexual Control Protocol™" sub="Instant digital access · One-time payment of $27 · Lifetime access · 7-Day Guarantee" data-id="element-176" data-mp="382wdk50akrgh" />
        </div>

        <div className="mt-8" data-id="element-177" data-mp="1dpda6ejkyen9">
          <Countdown note="Limited-time launch price: $27. The price may increase after the introductory launch period." data-id="element-178" data-mp="1dqevrcy82jj8" />
        </div>
      </div>
    </header>;
}